import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { dimColors } from '../constants';

// const getColor = value => {
//   if (value < 40) {
//     return polarColors[0];
//   }
//   return polarColors[4];
// };

const DecisionMakingThirdPage = ({ user, background, number }) => {
  // const { TOP_DECISION_STYLE } = user;
  const afrontNOProductivo = parseFloat(user['Afrontamiento No-Producivo']);

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>Afrontamiento No Productivo</h3>
          <p className='justified'>
            Los individuos que muestran altos puntajes en esta escala suelen
            recurrir a{' '}
            <strong>
              estrategias que, en lugar de facilitar, pueden obstaculizar el
              proceso de elección de carrera
            </strong>
            . Algunas de estas estrategias pueden ser postergar o evitar la toma
            de decisiones, esconder sus preocupaciones a otros, o centrarse en
            los aspectos negativos del proceso.
          </p>
          <p className='justified'>
            Por ejemplo, el tener mucha preocupación por elegir la carrera
            "equivocada" puede llevar a posponer la decisión hasta el último
            minuto, o evitar discutir el tema con los demás, guardándose para sí
            mismo sus dudas y preocupaciones. Esta mirada negativa puede llevar
            a un ciclo de evitación y ansiedad que impide una toma de decisiones
            efectiva.
          </p>
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Identificar los obstáculos.</li>
            <li>- Establecer pequeños objetivos.</li>
            <li>- Reconocer y manejar las emociones negativas.</li>
            <li>- Revisar las creencias irracionales.</li>
            <li>- Búsqueda de apoyo.</li>
          </ul>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <div className='progress-name'>Afrontamiento No Productivo</div>
                <ProgressBox
                  progress={afrontNOProductivo}
                  backColor={() => dimColors[2]}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{afrontNOProductivo}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DecisionMakingThirdPage;
